<template>
  <div class="carrier-activation">
    <!-- ヘッダー -->
    <SimpleHeader :contentName="''" />

    <div class="carrier-activation-inner flexcenter">
      <!-- 初期表示 -->
      <div v-if="!isTakeOver" class="carrier-activation-controls flexcenter">
        <button class="activate-carrier" type="button" @click="activateCarrier()"><span>アプリを新規に利用する</span></button>
        <p class="carrier-activation-error-activate-carrier m0" v-if="message">{{ message }}</p>
        <button class="activate-takeover" type="button" @click="changeDisplay()"><span>前の端末の学習情報を引き継ぐ</span></button>
      </div><!-- /.carrier-activation-controls -->
      <!-- 引継ぎ利用開始 -->
      <div v-else class="carrier-activation-controls flexcenter">
        <h3 class="font22">
          <div>前の端末の学習情報を引き継ぎます</div>
          <div>設定した引継ぎコードとパスワードを入力してください</div>
        </h3>
        <div class="takeovercode flexcenter">
          <input class="carrier-activation-text" type="text" v-model="takeOverCode" placeholder="引継ぎコード" maxlength="128" @keypress.enter="activateTakeOver()">
        </div>
        <div class="password flexcenter">
          <input class="carrier-activation-text" type="password" v-model="password" placeholder="パスワード (英数半角4～16文字)" maxlength="16" @keypress.enter="activateTakeOver()">
          <button class="enter" @click="activateTakeOver()"><img src="static/images/icon/svg/ar_r_login.svg" alt="login"></button>
        </div>
        <p class="carrier-activation-error-activate-takeover m0" v-if="message">{{ message }}</p>
        <button class="return" type="button" @click="changeDisplay()"><span>戻る</span></button>
      </div><!-- /.carrier-activation-controls -->
    </div><!-- /.inner -->
  </div><!-- /.carrier-activation -->
</template>

<script>
import SimpleHeader from '@/components/Header';
import common from '@/mixin/common';
import http from '@/mixin/http';
import * as constants from '@/mixin/constants';

export default {
  name: 'carrierActivation',
  data: function () {
    return {
      isTakeOver: false,
      takeOverCode: '',
      password: '',
      message: ''
    }
  },
  components: {
    SimpleHeader,
  },
  mixins: [
    common,
    http,
  ],
  methods: {
    /**
     * 画面表示切り替え
     */
    changeDisplay: function () {
      this.message = '';
      this.isTakeOver = !this.isTakeOver;
    },
    /**
     * この端末で新規に利用開始
     */
    activateCarrier: function () {
      var self = this;
      this.log("CarrierActivation start activateCarrier");

      // UUID取得
      var uuid = window.Phone.GetUuid();

      // キャリア版Androidアプリ利用開始APIを実行
      this.auActivate(uuid).then(function (response) {
        self.log("CarrierActivation resultCode: " + response.result_code);
        switch (response.result_code) {
          case 'OK':
            storage_wrapper.setRsAccessKey(response.access_key);
            self.$router.replace({ name: 'Root' });
            break;
          default:
            self.error(constants.ERR_UNKNOWN);
            break;
        }
      }).catch(function (err) {
        self.error(constants.ERR_UNKNOWN);
      });
    },
    /**
     * 他端末の情報を引き継いで利用開始
     */
    activateTakeOver: function () {
      var self = this;
      this.log("CarrierActivation start activateTakeOver");

      // 引き継ぎコード利用開始APIを実行
      this.takeOverActivate(this.takeOverCode, this.password).then(function (response) {
        self.log("CarrierActivation takeOverActivate resultCode: " + response.result_code);
        switch (response.result_code) {
          case 'OK':
            storage_wrapper.setRsAccessKey(response.access_key);
            self.$router.replace({ name: 'Root' });
            break;
          case 'WARN_INPUT_PARAM':
          case 'INFO_INVALID_CODE':
          case 'INFO_INVALID_PASSHASH':
            self.error(constants.ERR_INVALID_TAKEOVER);
            break;
          default:
            self.error(constants.ERR_UNKNOWN);
            break;
        }
      }).catch(function (err) {
        self.error(constants.ERR_UNKNOWN);
      });
    },
    /**
     * エラー処理
     *
     * @param {String} message エラーメッセージ
     */
    error: function(message) {
      this.message = message;
      this.password = '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/style/login';
</style>



// WEBPACK FOOTER //
// CarrierActivation.vue?82796080